import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginPage from './LoginPage';

export function RequireAuth({ children }) {
    const { user, loading, userDoc, userDocLoading } = useAuth();
    if (loading || userDocLoading) return <div></div>;
    if (!user) return <LoginPage />;
    if (!userDoc || !userDoc.allow) return <LoginPage />;
    return children;
}

export function RequireAdmin({ children }) {
    const { userDoc } = useAuth();
    if (!userDoc || !userDoc.admin) {
        return <Navigate to="/" replace />;
    }
    return children;
}
